import { toCenterDayKey } from '@/utils/timezone';
import { addMonths } from 'date-fns';

const PRESETS = [
  { months: 1, labelKey: 'endDateOptions.monthFromNow' },
  { months: 3, labelKey: 'endDateOptions.threeMonthsFromNow' },
  { months: 6, labelKey: 'endDateOptions.sixMonthsFromNow' },
] as const;

export const CUSTOM_END_DATE_VALUE = 'custom';

export interface RecurrenceEndDateOption {
  value: string;
  labelKey: (typeof PRESETS)[number]['labelKey'] | 'endDateOptions.customDate';
}

export const getRecurrenceEndDatePresetKeys = (today: Date, timeZone: string): string[] =>
  PRESETS.map(({ months }) => toCenterDayKey(addMonths(today, months), timeZone));

interface RecurrenceEndDateOptionsParams {
  today: Date;
  timeZone: string;
  firstSession: Date;
  maxRecurringDate?: Date;
}

export const getRecurrenceEndDateOptions = ({ today, timeZone, firstSession, maxRecurringDate }: RecurrenceEndDateOptionsParams): RecurrenceEndDateOption[] => {
  const isOfferable = (endDate: Date) => (!maxRecurringDate || endDate <= maxRecurringDate) && endDate >= firstSession;

  const presetOptions = PRESETS.flatMap(({ months, labelKey }) => {
    const endDate = addMonths(today, months);

    return isOfferable(endDate) ? [{ value: toCenterDayKey(endDate, timeZone), labelKey }] : [];
  });

  return [...presetOptions, { value: CUSTOM_END_DATE_VALUE, labelKey: 'endDateOptions.customDate' }];
};
